import {TableBodyRow} from '@components/ui/table-atoms/TableAtoms.tsx'
import styled from 'styled-components'

export const StyledTableBodyRow = styled(TableBodyRow)`
    cursor: pointer;
    &:not(:hover) .show-on-hover {
        transition: none;
        visibility: hidden;
    }
`
